var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-container course-sections-flex" },
    [
      _vm.showHomeSection
        ? _c("div", { staticClass: "class-nav-item" }, [
            _c(
              "a",
              {
                class: { "class-nav-item-disabled": _vm.isClassHome },
                attrs: { href: "#", disabled: _vm.isClassHome },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.goToHome($event)
                  }
                }
              },
              [
                _c(
                  "page-icon",
                  _vm._b({}, "page-icon", _vm.homeIconProps, false)
                ),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.classPage.ClassNav.classPage_classHome"
                      )
                    )
                  )
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.menu, function(item, itemIdx) {
        return _c(
          "div",
          { key: "menu-item-" + itemIdx, staticClass: "class-nav-item" },
          [
            _c(
              "a",
              {
                class: {
                  "class-nav-item-disabled":
                    _vm.currentSection === item.FOLDER_ID
                },
                attrs: {
                  href: "#",
                  disabled: _vm.currentSection === item.FOLDER_ID
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.goToSection(item.FOLDER_ID)
                  }
                }
              },
              [
                _c("page-icon", {
                  attrs: {
                    text: item.FOLDER_NAME.toString().charAt(0),
                    color: _vm.getColor(item),
                    size: _vm.size,
                    image: item.PAGE_ICON_URL
                      ? "url(" + item.PAGE_ICON_URL + ")"
                      : ""
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.FOLDER_NAME))
                ])
              ],
              1
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }